import { render, staticRenderFns } from "./PrescrizioneFarmacoComponent.vue?vue&type=template&id=08a6a536"
import script from "./PrescrizioneFarmacoComponent.vue?vue&type=script&lang=js"
export * from "./PrescrizioneFarmacoComponent.vue?vue&type=script&lang=js"
import style0 from "./PrescrizioneFarmacoComponent.vue?vue&type=style&index=0&id=08a6a536&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports